import { useEffect, useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { botanical, gallery } from '../data/site';

export default function Gallery() {
  const [selected, setSelected] = useState(null);
  useEffect(() => {
    if (selected === null) return undefined;
    const onKey = (event) => {
      if (event.key === 'Escape') setSelected(null);
      if (event.key === 'ArrowRight') setSelected((current) => (current + 1) % gallery.length);
      if (event.key === 'ArrowLeft') setSelected((current) => (current - 1 + gallery.length) % gallery.length);
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    document.getElementById('lightbox-close')?.focus();
    return () => { document.removeEventListener('keydown', onKey); document.body.style.overflow = ''; };
  }, [selected]);
  return (
    <section className="section gallery-section" id="gallery">
      <div className="container gallery-layout">
        <div className="gallery-intro"><span className="eyebrow">LIFE AT MINROSE</span><h2>Little Moments.<br />Wonderful Memories.</h2><p>Discover moments of learning, creativity, and connection.</p><a className="button button-dark" href="#gallery-photos">Explore Our Gallery <span aria-hidden="true">→</span></a></div>
        <div className="gallery-grid" id="gallery-photos">
          {gallery.map((item, index) => <button className={`gallery-tile tile-${index}`} key={item.title} onClick={() => setSelected(index)} aria-label={`View ${item.title} photograph`}>
            <img src={item.image} alt={item.title} loading="lazy" width="540" height="420" /><span>{item.title}</span>
          </button>)}
        </div>
        <div className="gallery-doodle" aria-hidden="true">Play<br />Learn<br />Grow<br />Belong <span>♡</span></div>
        <img className="botanical gallery-botanical" src={botanical} alt="" aria-hidden="true" loading="lazy" />
      </div>
      {selected !== null && <div className="lightbox" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) setSelected(null); }}>
        <div className="lightbox-content" role="dialog" aria-modal="true" aria-label={`Gallery photograph: ${gallery[selected].title}`}>
          <button id="lightbox-close" className="lightbox-close" onClick={() => setSelected(null)} aria-label="Close gallery"><SafeIcon icon={FiIcons.FiX} /></button>
          <button className="lightbox-prev" onClick={() => setSelected((selected - 1 + gallery.length) % gallery.length)} aria-label="Previous photograph"><SafeIcon icon={FiIcons.FiChevronLeft} /></button>
          <img src={gallery[selected].image} alt={gallery[selected].title} />
          <button className="lightbox-next" onClick={() => setSelected((selected + 1) % gallery.length)} aria-label="Next photograph"><SafeIcon icon={FiIcons.FiChevronRight} /></button>
          <p>{gallery[selected].title} · {selected + 1} of {gallery.length}</p>
        </div>
      </div>}
    </section>
  );
}